var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "IaPainelLateral",
    {
      attrs: {
        aberto: _vm.aberto,
        titulo: _vm.titulo,
        subtitulo: _vm.subtitulo,
        "rotulo-aba": _vm.rotuloAba
      },
      on: { abrir: _vm.abrir, fechar: _vm.fechar },
      scopedSlots: _vm._u([
        {
          key: "acoes",
          fn: function() {
            return [
              !_vm.mostrandoHistorico
                ? _c(
                    "button",
                    {
                      staticClass: "ia-painel-lateral__botao",
                      attrs: {
                        type: "button",
                        "data-test": "alternar-historico",
                        "aria-label": "Ver histórico",
                        title: "Ver histórico"
                      },
                      on: { click: _vm.alternarHistorico }
                    },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "clock-filled",
                          size: 18,
                          color: "var(--neutral-700)"
                        }
                      })
                    ],
                    1
                  )
                : _c(
                    "button",
                    {
                      staticClass:
                        "ia-painel-lateral__botao ia-painel-lateral__botao--texto",
                      attrs: {
                        type: "button",
                        "data-test": "alternar-historico",
                        "aria-label": "Voltar"
                      },
                      on: { click: _vm.alternarHistorico }
                    },
                    [
                      _c("icon-svg", {
                        attrs: {
                          name: "mdi-arrow-left",
                          size: 14,
                          color: "var(--neutral-700)"
                        }
                      }),
                      _vm._v(" Voltar ")
                    ],
                    1
                  ),
              _c(
                "button",
                {
                  staticClass: "ia-painel-lateral__botao",
                  attrs: {
                    type: "button",
                    "data-test": "nova-conversa",
                    "aria-label": "Novo chat",
                    title: "Novo chat"
                  },
                  on: { click: _vm.novaConversa }
                },
                [
                  _c("icon-svg", {
                    attrs: {
                      name: "add-circle",
                      size: 18,
                      color: "var(--neutral-700)"
                    }
                  })
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.mostrandoHistorico,
              expression: "!mostrandoHistorico"
            }
          ],
          staticClass: "consultor-painel__chat"
        },
        [
          _c("ViewChat", {
            attrs: {
              widget: "",
              "iniciar-conversa-nova": "",
              "enviar-pergunta-inicial": "",
              persona: _vm.personaId,
              "agente-id": _vm.agenteId,
              "origem-modulo": _vm.origemModulo,
              "pergunta-inicial": _vm.perguntaPendente
            },
            on: { "open-service": _vm.onOpenService }
          })
        ],
        1
      ),
      _vm.mostrandoHistorico
        ? _c(
            "div",
            { staticClass: "consultor-painel__historico" },
            [
              _c("Conversations", {
                on: {
                  select: _vm.abrirConversa,
                  "new-conversation": _vm.novaConversa,
                  delete: _vm.apagarConversa,
                  rename: _vm.renomearConversa
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }